import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/transmissions');
}
//Get all active
export function allActive(){
    return http().get('/transmissions/active');
}
//Get Single
export function single(id){
    return http().get(`/transmissions/${id}`);
}
//Add one
export function add(data){
    return http().post('/transmissions', data)
}
//Update
export function update(id, data){
    return http().put(`/transmissions/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/transmissions/${id}`);
}